
import styled from "styled-components";
import { Link } from "react-router-dom";
import { ReactComponent as TextLogo } from "../../assets/logo/horizon.svg";
import { useState } from "react";

const Container = styled.footer`
  position: static;
  bottom: 0;
  left: 0;
  right: 0;
  min-height: 95px;
  min-width: 1714px;
  margin-top: 161px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: rgb(135, 136, 144);
  &>a>svg{
    height: 32px;
    width: 128px;
    fill: black;
  }
  @media (max-width: 1024px) {
    flex-direction: column;
    justify-content: space-between;
    row-gap: 2vh;
  }
`
const CopyrightContainer = styled.div`
  position: absolute;
  left: 50%;
  right: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 1024px) {
    top: 1vh;
    left: auto;
    right: auto;
    position: relative;
  }
`
const CopyrightBox = styled.div`
  position: absolute;
  display: flex;
  column-gap: .5vw;
  width: max-content;
  @media (max-width: 1024px) {
    position: relative;
    flex-direction: column;
    text-align: center;
  }
`
const LoginButton = styled.button`
  position: absolute;
  left: 0;
  height: 7vh;
  width: 7vh;
  display: flex;
  align-items: center;
  &>a{
    flex: 1;
    width: 100%;
    padding: 20%;
    border-radius: 18px;
    color: white;
    font-weight: 700;
    background-color: #F5B919;
  }
  &>button{
    flex: 1;
    width: 100%;
    padding: 20%;
    border-radius: 18px;
    color: white;
    font-weight: 700;
    background-color: red;
  }
`

function Footer() {
  const [renderLoginButton, setRenderLoginButton] = useState(false);
  return (
    <Container>
      <Link to=""><TextLogo /></Link>
      <CopyrightContainer>
        <CopyrightBox>
          <div>Copyright © 더퍼스트에듀</div><div>All Rights Reserved.</div>
        </CopyrightBox>
      </CopyrightContainer>
      <div>
        <LoginButton
          onMouseOver={()=>setRenderLoginButton(true)}
          onMouseOut={()=>setRenderLoginButton(false)}
        >
          {renderLoginButton? <Link to={localStorage.getItem("theFirstEduLogin")===process.env.REACT_APP_LOGIN_HASH? "/admin" : "/login"}>Login</Link> : null}
          {localStorage.getItem("theFirstEduLogin")===process.env.REACT_APP_LOGIN_HASH&&renderLoginButton? <button onClick={()=>{localStorage.removeItem("theFirstEduLogin"); alert("로그아웃 되었습니다.");}}>Logout</button> : null} 
        </LoginButton>
      </div>
      <Link to="https://pf.kakao.com/_xlkZiG/chat" target="_blank"><div>고객센터</div></Link>
    </Container>
  );
}

export default Footer;
